import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './components/header/Header.tsx';
import Footer from './components/footer/Footer.tsx';
import Home from './pages/home/Home.tsx';
import Contact from './pages/contact/Contact.tsx';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Header />
          <div className="app-body">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </div>
        </div>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
